import React, { ReactNode, useEffect, useRef } from 'react';
import {
	TreeNavigation as StandardTreeNavigation,
	TreeNavigationItem as StandardTreeNavigationItem,
	TreeNavigationDropdown as StandardTreeNavigationDropdown,
} from '@emorg-prd/standard-react';
import { IconTypes } from '@emorg-prd/standard-react/components/Icon';
import './TreeNavigation.css';

interface TreeNavigationProps {
	children: ReactNode;
	optionalClass?: string;
}

export type TreeNavigationTextColor = 'default' | 'primary';

interface TreeNavigationItemProps {
	label: string;
	onClick?: () => void;
	optionalClass?: string;
	textColor?: TreeNavigationTextColor;
}

interface TreeNavigationDropdownProps {
	label: string;
	children: ReactNode;
    expanded?: boolean;
	bigIcon?: boolean; //Used for dropdown Arrow icon to be bigger
	optionalClass?: string;
	NavItemIcon?: boolean;
	iconName?: IconTypes;
	textColor?: TreeNavigationTextColor;
}

export const TreeNavigation: React.FC<TreeNavigationProps> = (props) => (
	<StandardTreeNavigation {...props} />
);

export const TreeNavigationItem: React.FC<TreeNavigationItemProps> = ({ optionalClass, onClick, textColor = 'default', ...props }) => (
	<StandardTreeNavigationItem
		{...props}
		// Prevents href="#" (the default link) from scrolling to the top of the page
		onClick={(e: React.MouseEvent) => { e.preventDefault(); onClick?.(); }}
		optionalClass={['custom-treenavigationItem', `custom-treenavigationItem--${textColor}`, optionalClass].filter(Boolean).join(' ')}
	/>
);

export const TreeNavigationDropdown: React.FC<TreeNavigationDropdownProps> = ({ bigIcon, optionalClass, textColor = 'default', ...props }) => {
	const baseClass = bigIcon
		? 'custom-treenavigationDropdownBig'
		: 'custom-treenavigationDropdown';
	const wrapperRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		// The standard component renders an <a href="#"> as the toggle trigger; remove href to prevent URL hash change
		wrapperRef.current?.querySelector('a.em-js-tree-dropdown-trigger')?.removeAttribute('href');
	});

	return (
		<div ref={wrapperRef}>
			<StandardTreeNavigationDropdown
				{...props}
				optionalClass={[baseClass, `custom-treenavigationDropdown--${textColor}`, optionalClass].filter(Boolean).join(' ')}
			/>
		</div>
	);
};
